export const CHAT_CONVERSATION_MESSAGES_READ_REQUEST = 'chat/conversation-messages-read-request'
export const CHAT_CONVERSATION_MESSAGES_READ_SUCCESS = 'chat/conversation-messages-read-success'
export const CHAT_CONVERSATION_MESSAGES_READ_FAILED = 'chat/conversation-messages-read-failed'
